// ボタンクリックで前の要素のis_hiddenクラスを外す
const accordionReadMore = () => {
    document.querySelectorAll('.js_readMore').forEach(js_readMore => {
        const btn = js_readMore.querySelector('.readMore_btn');
        const list = js_readMore.querySelector('ul');
        const content = js_readMore.querySelector('.readMore_content');

        if (list) {
            // --- リスト型 ---
            const items = list.querySelectorAll('li');
            if (items.length <= 1) {
                btn.style.display = 'none';
                return;
            }
            items.forEach((li, i) => { if (i > 0) li.classList.add('hidden'); });
            btn.addEventListener('click', () => {
                items.forEach(li => li.classList.remove('hidden'));
                btn.style.display = 'none'; // ボタン非表示
            });

        } else if (content) {
            // --- テキスト型 ---
            // 高さチェックで判定（pが1つでもOK）
            const needsButton = content.scrollHeight > content.clientHeight + 5;
            if (!needsButton) {
                btn.style.display = 'none';
                return;
            }
            btn.addEventListener('click', () => {
                content.classList.add('expanded');
                btn.style.display = 'none';
            });
        }
    });
}

export default accordionReadMore;